import React, { Component, Fragment } from 'react'
import { API_URL } from '../Actions/Config'
import { compose } from 'redux'
import { connect } from 'react-redux'
import OwlCarousel from "react-owl-carousel"
import Header from './Common/Header'
import Footer from './Common/Footer'
import Helmet from './Common/Helmet'
import Slider from './Common/Slider'
import HomeTourRow from './Common/HomeTourRow'
import {
	DayTour,
	MultiTour,
	ThingsToDo,
	Transfer,
	RentCAr,
	Maldives
} from '../Images'
import { getHomeTours, getSpecialTours, getDayTours, getRoundTours, getMaldiveTours } from "../Actions/HomeAction"
import "owl.carousel/dist/assets/owl.carousel.css"
import "owl.carousel/dist/assets/owl.theme.default.css"

const mapStateToProps = (state) => {
	return {
		tour: state.Tour
	}
}

const mapDispatchToProps = dispatch => ({
	getHomeTours: () => dispatch(getHomeTours()),
	getSpecialTours: () => dispatch(getSpecialTours()),
	getDayTours: () => dispatch(getDayTours()),
	getRoundTours: () => dispatch(getRoundTours()),
	getMaldiveTours: () => dispatch(getMaldiveTours()),
});

const stripTags = (html) => {
	if (!html) return "";
	return html.replace(/<[^>]*>/g, "");
};

const options = {
	margin: 5,
	items: 3,
	autoplay: false,
	dots: true,
	nav: true,
	navText: [
		'<span aria-label="Previous">&#8249;</span>',
		'<span aria-label="Next">&#8250;</span>'
	]
}

function getThingsUrl(tour) {
	var url = ""
	url = "/things-to-do/" + tour.permalink
	return url
}

class Home extends Component {

	constructor(props) {
		super(props);

		this.state = {
			loca: "",
			id: ""
		}
		this.props.getHomeTours()
		this.props.getSpecialTours()
		this.props.getDayTours()
		this.props.getRoundTours()
		this.props.getMaldiveTours()
	}


	render() {
		return <Fragment>
			<Header home={true} />
			<Helmet
				title="Beyond Escapes - Online Booking for Sri Lanka & Maldives Tours"
				description={"Discover and book the best holidays, authentic experiences, and top tourist places in Sri Lanka & Maldives. Choose from over 500 tours, day trips, and activities. Unlock amazing travel deals and explore the wonders of these enchanting destinations. Start your journey today! #escapetosrilanka"}
			/>
			{this.props.tour.sliders.length > 0 ?
				<Slider
					sliders={this.props.tour.sliders}
				/> : null}


			<div className="slid-bot">
				<a href='/day-tours' className="daytor">
					<span><img src={DayTour} width="41" height="56" /></span>Day Tours
				</a>
				<a href='/round-tours' className="maltyday">
					<span><img src={MultiTour} width="46" height="61" /></span>multiday tours
				</a>
				<a href='/things-to-do' className="thinstodo">
					<span><img src={ThingsToDo} width="57" height="60" /></span>things to do
				</a>
				<a href="/vehicle-transfers" className="transfer">
					<span><img src={Transfer} width="55" height="61" /></span>transfers
				</a>
				<a href='/transport' className="transport">
					<span><img src={RentCAr} width="62" height="57" /></span>Rent a Car
				</a>
				<a href='/maldives' className="male">
					<span><img src={Maldives} width="55" height="62" /></span>maldives
				</a>
				<div className="clear"></div>
			</div>
			{this.props.tour.specialTours.length > 0 ?
				<HomeTourRow
					title="Special Offers"
					tours={this.props.tour.specialTours}
					showMore="/special"
				/> : null}
			{this.props.tour.dayTours.length > 0 ?
				<HomeTourRow
					title="Day Tours"
					tours={this.props.tour.dayTours}
					showMore="/day-tours"
				/> : null}
			{this.props.tour.roundTours.length > 0 ?
				<HomeTourRow
					title="Round Tours"
					tours={this.props.tour.roundTours}
					showMore="/round-tours"
				/> : null}
			{this.props.tour.maldiveTours.length > 0 ?
				<HomeTourRow
					title="Maldives Tours"
					tours={this.props.tour.maldiveTours}
					showMore="/maldives"
				/> : null}
			{this.props.tour.serves.length > 0 ?
				<section className="dfup">
					<div className="container">
						<div className="row">
							<div className="col-md-12">
								<div className="dfup-div">
									<img src={API_URL + "/web/img/headphones.png"} width="34" height="34" />
									<h4>{stripTags(this.props.tour.serves[0]?.title)}</h4>
									<p>{stripTags(this.props.tour.serves[0]?.description)}</p>
									<a href="/contact-us">Reach us</a>
								</div>
							</div>
						</div>
					</div>
				</section>
				: null}
			{this.props.tour.excursions.length > 0 ?
				<section class="histo-do">
					<div class="container">
						<div class="row">
							<div class="col-lg-12">
								<div class="histo-div">
									<h4>Things you can do </h4>

									<div class="row">
										<div class="col-lg-6">
											<div class="row">
												<div class="col-lg-6 col-md-6">
													<a href={getThingsUrl(this.props.tour.excursions[0])}>
														<div class="thin smal">
															<img src={API_URL + this.props.tour.excursions[0].home_image} width="265" height="209" />
															<h6>{this.props.tour.excursions[0].name}</h6>
														</div>
													</a>
												</div>
												<div class="col-lg-6 col-md-6">
													<a href={getThingsUrl(this.props.tour.excursions[1])}>
														<div class="thin smal">
															<img src={API_URL + this.props.tour.excursions[1].home_image} width="265" height="209" />
															<h6>{this.props.tour.excursions[1].name}</h6>
														</div>
													</a>
												</div>
											</div>
										</div>
										<div class="col-lg-6">
											<div class="row">
												<div class="col-lg-6 col-md-6">
													<a href={getThingsUrl(this.props.tour.excursions[2])}>
														<div class="thin smal">
															<img src={API_URL + this.props.tour.excursions[2].home_image} width="265" height="209" />
															<h6>{this.props.tour.excursions[2].name}</h6>
														</div>
													</a>
												</div>
												<div class="col-lg-6 col-md-6">
													<a href={getThingsUrl(this.props.tour.excursions[3])}>
														<div class="thin smal">
															<img src={API_URL + this.props.tour.excursions[3].home_image} width="265" height="209" />
															<h6>{this.props.tour.excursions[3].name}</h6>
														</div>
													</a>
												</div>
											</div>
										</div>
									</div>

									<div class="row">
										<div class="col-lg-6">
											<a href={getThingsUrl(this.props.tour.excursions[4])}>
												<div class="thin big">
													<img src={API_URL + this.props.tour.excursions[4].home_image} width="550" height="434" />
													<h6>{this.props.tour.excursions[4].name}</h6>
												</div>
											</a>
										</div>
										<div class="col-lg-6">
											<a href={getThingsUrl(this.props.tour.excursions[0])}>
												<div class="thin big">
													<img src={API_URL + this.props.tour.excursions[5].home_image} width="550" height="434" />
													<h6>{this.props.tour.excursions[5].name}</h6>
												</div>
											</a>
										</div>
									</div>

									<div class="row">
										<div class="col-lg-6">
											<div class="row">
												<div class="col-lg-6 col-md-6">
													<a href={getThingsUrl(this.props.tour.excursions[6])}>
														<div class="thin smal">
															<img src={API_URL + this.props.tour.excursions[6].home_image} width="265" height="209" />
															<h6>{this.props.tour.excursions[6].name}</h6>
														</div>
													</a>
												</div>
												<div class="col-lg-6 col-md-6">
													<a href={getThingsUrl(this.props.tour.excursions[7])}>
														<div class="thin smal">
															<img src={API_URL + this.props.tour.excursions[7].home_image} width="265" height="209" />
															<h6>{this.props.tour.excursions[7].name}</h6>
														</div>
													</a>
												</div>
											</div>
										</div>
										<div class="col-lg-6">
											<a href={getThingsUrl(this.props.tour.excursions[8])}>
												<div class="thin mid">
													<img src={API_URL + this.props.tour.excursions[8].home_image} width="550" height="378" />
													<h6>{this.props.tour.excursions[8].name}</h6>
												</div>
											</a>
										</div>
									</div>

									<div class="row">
										<div class="col-lg-6">
											<a href={getThingsUrl(this.props.tour.excursions[9])}>
												<div class="thin mid">
													<img src={API_URL + this.props.tour.excursions[9].home_image} width="550" height="378" />
													<h6>{this.props.tour.excursions[9].name}</h6>
												</div>
											</a>
											<a href={getThingsUrl(this.props.tour.excursions[10])}>
												<div class="thin big">
													<img src={API_URL + this.props.tour.excursions[10].home_image} width="550" height="434" />
													<h6>{this.props.tour.excursions[10].name}</h6>
												</div>
											</a>
										</div>
										<div class="col-lg-6">
											<a href={getThingsUrl(this.props.tour.excursions[11])}>
												<div class="thin big">
													<img src={API_URL + this.props.tour.excursions[11].home_image} width="550" height="434" />
													<h6>{this.props.tour.excursions[11].name}</h6>
												</div>
											</a>
											<div class="row">
												<div class="col-lg-6 col-md-6">
													<a href={getThingsUrl(this.props.tour.excursions[12])}>
														<div class="thin smal">
															<img src={API_URL + this.props.tour.excursions[12].home_image} width="265" height="209" />
															<h6>{this.props.tour.excursions[12].name}</h6>
														</div>
													</a>
												</div>
												<div class="col-lg-6 col-md-6">
													<a href={getThingsUrl(this.props.tour.excursions[13])}>
														<div class="thin smal">
															<img src={API_URL + this.props.tour.excursions[13].home_image} width="265" height="209" />
															<h6>{this.props.tour.excursions[13].name}</h6>
														</div>
													</a>
												</div>
											</div>
										</div>
									</div>
								</div>

							</div>

						</div>

					</div>

				</section>
				: null}

			{this.props.tour.serves.length > 0 ?
				<section className="dfup">
					<div className="container">
						<div className="row">
							<div className="col-md-12">
								<div className="dfup-div">
									<img src={API_URL + "/web/img/bag.png"} width="34" height="34" />
									<h4>{stripTags(this.props.tour.serves[1]?.title)}</h4>
									<p>{stripTags(this.props.tour.serves[1]?.description)}</p>
									<a href="/contact-us">Reach us</a>
								</div>
							</div>
						</div>
					</div>
				</section>
				: null}
			{this.props.tour.travelEssential != null ?
				<section className="travel-section">
					<div className="container">
						<div className="row">
							<div className="col-lg-12">
								<div className="rit">
									<h3>Travel<br />Essential</h3>
									<div className="rit-te">
										{this.props.tour.travelEssential.accommodation ?
											<a href="/travel-essential#section1"><span><img src={API_URL + '/web/img/accommodation.png'} width="31" height="25" /></span>Accommodation  </a>
											: null}
										{this.props.tour.travelEssential.security ?
											<a href="/travel-essential#section2"><span><img src={API_URL + '/web/img/Security.png'} width="21" height="28" /></span>Security  </a>
											: null}
										{this.props.tour.travelEssential.telecommunication ?
											<a href="/travel-essential#section3"><span><img src={API_URL + '/web/img/Telecommunication.png'} width="28" height="28" /></span>Telecommunication </a>
											: null}
										{this.props.tour.travelEssential.emergency ?
											<a href="/travel-essential#section4"><span><img src={API_URL + '/web/img/Emergency.png'} width="26" height="34" /></span>Emergency</a>
											: null}
										{this.props.tour.travelEssential.visaDocuments ?
											<a href="/travel-essential#section5"><span><img src={API_URL + '/web/img/Visa.png'} width="26" height="29" /></span>Visa & Documents</a>
											: null}
										{this.props.tour.travelEssential.language ?
											<a href="/travel-essential#section6"><span><img src={API_URL + '/web/img/Language.png'} width="34" height="30" /></span>Language</a>
											: null}
										<span className="clear"> </span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				: null}


			<section className="travel-blog">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<div className="blg">
								<h4>Travel Blog</h4>
								<p>Read Latest Travel & Tourism Updates.</p>
								{this.props.tour.latestNews.length > 0 ?
									<OwlCarousel className="owl-carousel owl-theme" id="owl-blog" {...options} loop={true} key={this.props.tour.latestNews.length}>
										{this.props.tour.latestNews.map((news, index) => (
											<div className="item">
												<div className="blog-div">
													<div className="blo-img">
														<img src={API_URL + (news.home_image != '' ? news.home_image : news.thumb)} width="352" height="312" />
													</div>
													<div>
														<span> </span>
														<h6> {news.title}</h6>
														<a href={"/blog/" + (news.permalink != null ? news.permalink : news.title)}>Read more</a>
													</div>
												</div>
											</div>))}
									</OwlCarousel> : null}
								<a href="/blog">ALL BLOGS</a>
							</div>
						</div>
					</div>
				</div>
			</section>

			<Footer hyperLink={false} />
		</Fragment>
	}
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(Home);
